<form #scaleForm="ngForm" class="stewards-modal">
  <div class="modal-header stewards-modal-header">
    <h4 class="modal-title text-truncate">False Start</h4>
    <button type="button" class="stewards-modal-close" (click)="cancel('cancel')" aria-label="Close">
      <fa name="times"></fa>
    </button>
  </div>
  <div class="modal-body stewards-modal-body">
    <div class="row">
      <div class="col">
        <p class="stewards-modal-text">You're going to flag this race as 'False Start'.<br>Please confirm this decision.</p>
        <p class="stewards-modal-warning mb-0">This action cannot be reverted.</p>
      </div>
    </div>
  </div>
  <div *ngIf="!meta.saving" class="modal-footer stewards-modal-footer">
    <button type="button" class="btn btn-outline-secondary stewards-modal-btn-close" (click)="cancel('cancel')">Close</button>
    <button type="button" class="btn btn-primary" (click)="confirm()">Confirm</button>
  </div>
  <div *ngIf="meta.saving" class="modal-footer stewards-modal-footer stewards-modal-footer-loading">
    <fa name="circle-o-notch" animation="spin"></fa>
  </div>
</form>
